'use strict';

var merge = require('merge');

module.exports = function (filter) {

  var mergedFilter = this.opts.filterByColumn ? merge(this.query, filter) : filter;

  if (this.vuex) {
    this.commit('SET_FILTER', mergedFilter);
  } else {
    this.query = mergedFilter;
    this.setPage(1, true);
  }

  this._setFiltersDOM(filter);

  if (this.source == 'server') {
    this.getData();
  }
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/set-filter.js